import React from "react";

const WarningIcon20pxSvg = ({
    color = "#D00D00",
    width = 20,
    height = 20,
    ...props
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M16.2586 4.87435L11.3086 2.01602C10.5003 1.54935 9.50026 1.54935 8.68359 2.01602L3.74193 4.87435C2.93359 5.34102 2.43359 6.20768 2.43359 7.14935V12.8493C2.43359 13.7827 2.93359 14.6493 3.74193 15.1243L8.69193 17.9827C9.50026 18.4493 10.5003 18.4493 11.3169 17.9827L16.2669 15.1243C17.0753 14.6577 17.5753 13.791 17.5753 12.8493V7.14935C17.5669 6.20768 17.0669 5.34935 16.2586 4.87435ZM9.37526 6.45768C9.37526 6.11602 9.65859 5.83268 10.0003 5.83268C10.3419 5.83268 10.6253 6.11602 10.6253 6.45768V10.8327C10.6253 11.1743 10.3419 11.4577 10.0003 11.4577C9.65859 11.4577 9.37526 11.1743 9.37526 10.8327V6.45768ZM10.7669 13.8577C10.7253 13.9577 10.6669 14.0493 10.5919 14.1327C10.4336 14.291 10.2253 14.3743 10.0003 14.3743C9.89193 14.3743 9.78359 14.3493 9.68359 14.3077C9.57526 14.266 9.49193 14.2077 9.40859 14.1327C9.33359 14.0493 9.27526 13.9577 9.22526 13.8577C9.18359 13.7577 9.16693 13.6493 9.16693 13.541C9.16693 13.3243 9.25026 13.1077 9.40859 12.9493C9.49193 12.8743 9.57526 12.816 9.68359 12.7743C9.99193 12.641 10.3586 12.716 10.5919 12.9493C10.6669 13.0327 10.7253 13.116 10.7669 13.2243C10.8086 13.3243 10.8336 13.4327 10.8336 13.541C10.8336 13.6493 10.8086 13.7577 10.7669 13.8577Z" fill={color} />
        </svg>

    );
};

export default WarningIcon20pxSvg;